// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Ow4I","name":"Header_name__1Xqxh","birthday":"Header_birthday__3oXa3","skeleton":"Header_skeleton__1taXK"};